/**
 * 알림 LINK_URL → 실제 프론트 라우트 (레거시/시드 경로 보정)
 */
export function resolveInboxLinkUrl(
  linkUrl: string,
  jurisdiction?: string | null
): string {
  if (!linkUrl || linkUrl.startsWith('http')) return linkUrl;

  const aliases: Record<string, string> = {
    '/startTask/tasks': '/tasks',
    '/startTask': '/tasks'
  };

  let path = aliases[linkUrl] ?? linkUrl;
  const jd = String(jurisdiction ?? '').toUpperCase();

  if (jd === 'MY' || jd === 'MALAYSIA') {
    if (path === '/Entity' || path === '/entity') {
      path = '/entity_my';
    }
  }

  return path;
}
